<template>
  <v-container>
    <p
      class="listTotalHeader"
      v-if="this.totalContracts && this.totalContracts > 0"
    >
      {{ `${this.totalContracts} Contracts found` }}
    </p>
    <Loader v-if="isLoading" />
    <Empty v-else-if="contracts && contracts.length == 0"/>
    <b-table
      v-else-if="!isLoading"
      :data="contracts"
      class="table"
	  v-bind:mobileCards="false"
    >
      <template slot-scope="props">
        <b-table-column field="address" label="Contract Address">
          <router-link
            v-if="props.row.address"
            class="router-link short-addr"
            :to="{ name: 'address', params: {address: props.row.address}}"
          >
            {{ props.row.address }}
          </router-link>
        </b-table-column>
        <b-table-column field="creator" label="Creator Address">
          <router-link
            v-if="props.row.creator && props.row.creator !== '0x'"
            class="router-link short-addr"
            :to="{ name: 'address', params: {address: props.row.creator}}"
          >
            {{ props.row.creator }}
          </router-link>

        </b-table-column>
        <b-table-column field="hash" label="Transaction Hash">
          <div v-if="props.row.txhash && props.row.txhash.length < 40">
            {{ props.row.txhash }}
          </div>
          <router-link
            v-else
            class="router-link short-addr"
            :to="{ name: 'tx', params: {txhash: props.row.txhash}}"
          >
            {{ props.row.txhash }}
          </router-link>
        </b-table-column>
        <b-table-column field="blockNumber" label="Block Height">
          <router-link
            class="router-link"
            :to="{ name: 'block', params: {blockNumber: props.row.blockNumber}}"
          >
            {{ props.row.blockNumber }}
          </router-link>
        </b-table-column>
      </template>

    </b-table>
    <el-pagination
      small
      background
      @current-change="shift"
      @prev-click="shift(currentPage-1)"
      @next-click="shift(currentPage+1)"
      :current-page="currentPage"
      layout="prev, pager, next"
      :pager-count=5
      :page-size="pageSize"
      :total="totalContracts">
    </el-pagination>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '../reusables/loader.vue';
import Empty from '../reusables/empty.vue';

export default {
  name: 'Contracts',
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      isLoading: false,
    };
  },
  components: {
    Loader,
    Empty,
  },
  watch: {
    contracts() {
      this.isLoading = false;
    },
    '$route.query.page': function (newPage) {
      this.initData(newPage);
    },
  },
  filters: {
    convertToScientificNotation(number) {
      return number.toString().length >= 18
        ? parseInt(number).toExponential(3)
        : number;
    },
  },
  methods: {
    initData(page) {
      if (!isNaN(page)) {
        const pageQuery = parseInt(page);
        this.currentPage = pageQuery;
        this.isLoading = true;
        this.$store.dispatch('fetchContracts', {
          limit: this.pageSize,
          page: pageQuery,
        });
      }
    },
    shift(page) {
      this.$router.push({ path: this.$route.path, query: { page } });
    },
    onCopy(e) {
      toast.copied(`${e.text.substring(0, 10)}...`);
    },
    onError() {
      this.$notify.error({
        title: 'Error',
        message: 'Failed to copy address',
        duartion: 10,
      });
    },
    appendQueries() {
      const pageQuery = parseInt(this.$route.query.page);
      this.currentPage = pageQuery;
      this.$router.push({
        path: this.$route.path,
        query: { page: pageQuery || 1 },
      });
      this.initData(pageQuery);
    },
  },

  computed: {
    ...mapGetters(['contracts', 'totalContracts', 'fetchError']),
  },

  created() {
    this.appendQueries();
  },
};
</script>

<style lang="scss">
</style>
